// Lib
import React from 'react';
import EmojiImage from '../../../emoji/EmojiImage';
import { NodeViewProps } from '@tiptap/core';

interface CalloutNodeViewIconReadOnlyProps {
    node: NodeViewProps['node'];
}

const CalloutNodeViewIconReadOnly: React.FC<CalloutNodeViewIconReadOnlyProps> = (props) => {
    const { node } = props;

    return (
        <div className="CalloutNodeViewIcon">
            <div className="trigger" contentEditable={false}>
                <EmojiImage emojiCode={node.attrs.iconCode} size={18} />
            </div>
        </div>
    );
};

export default CalloutNodeViewIconReadOnly;
